import { ExternalInvitation } from '@/domain/external-invitation/entities/external-invitation.entity';
import { getCategories } from '@/domain/external-invitation/utils/category/get-categories';
import { StakeholderItem } from '@/ui/pages/app/components/stakeholders/ModalStakeholders';

type InvitationsPerSector = {
  TEAM: ExternalInvitation[];
  ARTISTS: ExternalInvitation[];
  PUBLIC: ExternalInvitation[];
  SITE: ExternalInvitation[];
};

export function prepareModalStakeholdersItems(
  invitationsPerSector: InvitationsPerSector,
): StakeholderItem[] {
  return [
    {
      sector: 'TEAM',
      existingInvitations: invitationsPerSector['TEAM'],
      categories: getCategories('festival', 'TEAM'),
    },
    {
      sector: 'ARTISTS',
      existingInvitations: invitationsPerSector['ARTISTS'],
      categories: getCategories('festival', 'ARTISTS'),
    },
    {
      sector: 'PUBLIC',
      existingInvitations: invitationsPerSector['PUBLIC'],
      categories: getCategories('festival', 'PUBLIC'),
    },
    {
      sector: 'SITE',
      existingInvitations: invitationsPerSector['SITE'],
      categories: getCategories('festival', 'SITE'),
    },
  ];
}
